import { layers, namedFlavor } from '@protomaps/basemaps';
/**
 * Der Kartenstil — für Fahransicht und Planung derselbe.
 *
 * Kartendaten, Schriften und Symbole kommen ausnahmslos vom eigenen Server.
 * Das ist keine Sparsamkeit: Jede Kachel, die von fremder Stelle geladen würde,
 * verriete dem Anbieter, wo jemand gerade hinsieht — und damit mittelbar, wo er
 * gerade ist. Genau das soll die Anwendung nicht tun.
 */
/*
 * Die Kartendatei — unter festem Namen, unabhängig vom Gebiet.
 *
 * Wie das Gebiet heißt, steht in .env und nirgends sonst; der Reverse Proxy
 * übersetzt `karte.pmtiles` auf die tatsächliche Datei. Stünde der Name auch
 * hier, zeigte die Oberfläche nach jedem neuen Zuschnitt auf eine Datei, die es
 * nicht mehr gibt — und die Karte bliebe leer, ohne dass jemand wüsste, warum.
 */
export const TILE_URL = `${window.location.origin}/tiles/karte.pmtiles`;
export function buildStyle(dunkel) {
    return {
        version: 8,
        glyphs: '/kartendaten/fonts/{fontstack}/{range}.pbf',
        sprite: `${window.location.origin}/kartendaten/sprites/v4/${dunkel ? 'dark' : 'light'}`,
        sources: {
            protomaps: {
                type: 'vector',
                url: `pmtiles://${TILE_URL}`,
                attribution: '© OpenStreetMap-Mitwirkende',
            },
        },
        // Ortsnamen auf Deutsch, soweit die Daten sie hergeben.
        layers: layers('protomaps', namedFlavor(dunkel ? 'dark' : 'light'), { lang: 'de' }),
    };
}
//# sourceMappingURL=style.js.map